VjsAdmin.LicenseEditForm = (function () {
    const me = {};
    me.original_form = null;
    me.order_by = 'district_id';
    me.sort_order = 'desc';
    me.table_height = window.innerHeight * 0.65;

    me.init = function () {
        $('#grade_ids').multiselect({
            enableClickableOptGroups: true,
        });
        $('#user_access_grade_ids').multiselect({
            enableClickableOptGroups: true,
        });
        // save original state of form, for checking for changes
        me.original_form = $('#license-edit-form').serialize();
        // //disabled license edit form submit button, until there are changes
        // $('#license-edit-form input[type=submit]').prop('disabled',true);
        //
        // //only enable save button if form values have changed at all
        // $('#license-edit-form :input').on('change input', function() {
        // $('#license-edit-form input[type=submit]').prop('disabled',($('#license-edit-form').serialize() === me.original_form));
        // });

        me.order_by = $.urlParam('order_by') !== null ? $.urlParam('order_by') : 'district_id';
        me.sort_order = $.urlParam('sort_order') !== null ? $.urlParam('sort_order') : 'desc';

        $('.unlock-district-field').on('mousedown', () => {
            $('.unlock-district-field .fa').toggleClass('fa-unlock').toggleClass('fa-lock');
            $('#district_id').prop('disabled', !$('#district_id').prop('disabled'));
        });

        $('#district_id').on('mousedown', (e) => {
            e.preventDefault();

            const content = $('<div>').html($('#change-district-template').html());
            const submitButton = $(
                '<button type="button" class="btn btn-green" id="change-district-button" disabled>Change District</button>',
            );

            const onShown = function () {
                me.initTable();
            };

            $(submitButton).on('click', (ee) => {
                ee.preventDefault();
                const districtId = me.$table.bootstrapTable('getSelections')[0].district_joint_guid;
                const name = typeof me.$table.bootstrapTable('getSelections')[0].display_name !== 'undefined'
                    ? me.$table.bootstrapTable('getSelections')[0].display_name
                    : me.$table.bootstrapTable('getSelections')[0].name;
                $('#district_id > option').val(districtId);
                $('#district_id > option').text(name);
                $('#district_id').change();
                $('.unlock-district-field').remove();
                me.$modal.modal('hide');
            });

            me.$modal = VjsAdmin.Modal.create({
                title: 'Change District',
                body: content,
                footer: submitButton,
                onShown,
            });

            me.$modal.modal();

            return false;
        });

        $(".form-check-input[name='disable_links']").on('change', (e) => {
            e.preventDefault();
            const enabled = e.currentTarget.id === 'disable-links-yes';
            me.disable_links_confirmed = false;

            const cancelButton = document.createElement('button');
            cancelButton.type = 'button';
            cancelButton.className = 'btn btn-green';
            cancelButton.innerText = 'Cancel';
            cancelButton.id = 'cancel-disable-links-change';
            cancelButton.setAttribute('data-dismiss', 'modal');
            $(cancelButton).on('click', () => {
                const checkboxYes = $('#disable-links-yes');
                const checkboxNo = $('#disable-links-no');

                if (checkboxYes.is(':checked')) {
                    checkboxYes.prop('checked', false);
                    checkboxNo.prop('checked', true);
                } else {
                    checkboxNo.prop('checked', false);
                    checkboxYes.prop('checked', true);
                }
            });

            const confirmButton = document.createElement('button');
            confirmButton.type = 'button';
            confirmButton.className = 'btn btn-danger';
            confirmButton.innerText = 'I Understand the Consequences';
            confirmButton.setAttribute('data-dismiss', 'modal');
            $(confirmButton).on('clicked', (ee) => {
                ee.preventDefault();
                me.disable_links_confirmed = true;
            });

            let content = 'Are you sure? This will disable all external links and Flex Lessons for this license.';

            if (!enabled) {
                content = 'CAUTION! You are removing the disable links setting from this license. Links will no longer be disabled.';
            }

            const footer = document.createElement('div');
            footer.append(cancelButton);
            footer.append(confirmButton);

            me.$modal = VjsAdmin.Modal.create({
                id: 'disable-links-modal',
                title: 'CAUTION!!! Dangerous Setting Change',
                body: content,
                footer,
                no_close: true,
            });

            me.$modal.data('keyboard', false);
            me.$modal.data('backdrop', 'static');

            me.$modal.modal();
        });
    };

    me.queryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.sort_order = me.sort_order;
        myParams.order_by = me.order_by;
        myParams.searchTerm = $('.fixed-table-toolbar .search > input').val();
        myParams.platform_id = $('#districts-table').attr('data-platform-id');
        myParams.organization_id = $('#districts-table').attr('data-organization-id');
        return myParams;
    };

    me.initTable = function () {
        me.$table = $('#districts-table');
        me.$table.bootstrapTable('destroy');
        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No districts ${typeof searchTerm !== 'undefined' ? ` matching search term \`${searchTerm}\`` : ''}`;
            },
            queryParams: me.queryParams,
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: 'district_id',
            height: me.table_height,
            singleSelect: true,
            clickToSelect: true,
            maintainSelected: true,
            onCheck() {
                $('#change-district-button').prop('disabled', false);
            },
            url: Slim.Router.pathFor('districts.list.json'),
            columns: [
                {
                    title: '',
                    field: 'selected',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    radio: true,
                },
                {
                    title: 'ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state_code',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row.is_active = row.active;
                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }
                });
                return formattedResult;
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.order_by = name;
                me.sort_order = order;
            },
        });
    };

    return {
        init: me.init,
    };
}());
